







































import {
  Component,
  ComponentStyle,
  ComponentStyleDefinition,
  InjectComponent,
  Prop,
  Vue,
  VueComponent,
} from "@zoovu/runner-browser-api";
import { FilterChoiceAnswerView } from "@zoovu/runner-web-design-base";
import { sanitize } from "dompurify";
import { isMobile } from "@zoovu/design-system/src/helpers";
import TooltipService from "../services/tooltip-service";
import { whitelistedAttributes } from "../types";

@Component({ name: "FilterChoiceAnswerView", mixins: [FilterChoiceAnswerView] })
export default class FilterChoiceAnswerViewExtended extends Vue {
  @InjectComponent("Modal")
  modal: VueComponent;

  @ComponentStyle()
  componentStyle!: ComponentStyleDefinition;

  @Prop()
  private showDisabledAnswers!: boolean;

  @Prop()
  private hideOptionLabels!: boolean;

  isMobile: boolean = isMobile();

  infoTextShown = false;

  get shouldBeShown(): boolean {
    return this.answer && (!this.answer.disabled || this.showDisabledAnswers);
  }

  mounted(): void {
    if (this.infoTextContent && !this.isMobile && !this.answer.disabled) {
      TooltipService.createTooltip(`#${this.answer.mid}-wrapper .info-text-trigger`, {
        content: sanitize(this.infoTextContent, { ADD_ATTR: whitelistedAttributes }),
        trigger: "mouseenter",
        placement: "top",
        distance: 10,
      });
    }
  }

  clickOnInfoText(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (!this.isMobile) return;
    this.showInfoText();
  }

  showInfoText(): void {
    this.infoTextShown = true;
  }

  hideInfoText(): void {
    this.infoTextShown = false;
  }

  toggleShowAllAnswers(): void {
    this.showAllAnswers = !this.showAllAnswers;
  }

  triggerClass(): string {
    return `answer-info-text-trigger answer-info-text-trigger-${this.answer.id}`;
  }
}
